const attachmentsToFileSelector = attachments => {
  if (!attachments) return [];
  return attachments.map(attachment => ({
    src: '',
    fileType: findLastName(attachment.fileName),
    name: attachment.fileName,
    ...attachment
  }));
};
const findLastName = fileName => {
  var fileSuffix = fileName.split(".").slice(-1)[0];
  fileSuffix = fileSuffix === "docx" ? "document" : fileSuffix;
  fileSuffix = fileSuffix === "xlsx" ? "sheet" : fileSuffix;
  return acceptedFileTypes.find(x => x.indexOf(fileSuffix) > -1);
};
const acceptedFileTypes = ["image/jpg", "image/jpeg", "image/png", "image/gif", "application/msword", "application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "text/csv"];
function truncateFileName(name, maxLength = 50) {
  const extension = name.slice(name.lastIndexOf('.'));
  if (name.length > maxLength) {
    return name.substring(0, maxLength - extension.length) + '...' + extension;
  }
  return name;
}
const generateRandomID = () => {
  return Math.floor(Math.random() * 0xFFFFFFFF).toString(16);
};
export { attachmentsToFileSelector, acceptedFileTypes, truncateFileName, generateRandomID };